import React from "react"
import _ from "lodash"

export default function TypeCheckbox({ value }) {
  return <div>{value ? _.toString(value) : "N/A"} </div>
}
